// localStorage API re-exposed to allow testing.
import { localStorage } from "./globals";
export const isSupported = localStorage != null && typeof localStorage.getItem === "function" && typeof localStorage.setItem === "function";
export function getItem(k) {
    if (isSupported && localStorage) {
        return localStorage.getItem(k);
    }
    return null;
}
export function setItem(k, v) {
    if (isSupported && localStorage) {
        localStorage.setItem(k, v);
    }
}
export function removeItem(k) {
    if (isSupported && localStorage) {
        localStorage.removeItem(k);
    }
}
